import PaginationFootballProperties from "../../../Football/Models/Pagination/PaginationFootballProperties";

export default class LoyaltyMeta {
    public rankType: string = null;
    public fromDate: string = null;
    public toDate: string = null;
    public pagination: PaginationFootballProperties = new PaginationFootballProperties();
}